import { TemplateElement } from '../../01-base/TemplateElement';
import style from '../SvgSprite/SvgIcon.css';

class SearchSuggestionElement extends TemplateElement {
    properties() {
        return {
            keywords: [],
            action: '',
        };
    }
    constructor() {
        super(null, { autoRender: true, shadowRender: false, styles: [style] });
    }
    template() {
        if (typeof this.keywords !== undefined && this.keywords.length > 0) {
            return `
<div class="suggestion-box position-absolute w-100">
            <ul id="suggestionUlList" ref="list" class="suggestion-item-list list-group">
        ${this.keywords
            .map((keyword, index) => {
                if (index < 5) {
                    return `
        <button class="suggestion-button" onclick="location.href='${this.action}?search=${keyword}';" >
            <li data-suggestion="${keyword}" class="suggestion-item list-group-item font-italic">${keyword}</li>
        </button>
        `;
                } else {
                    return '';
                }
            })
            .join('')}
        </ul>
        </div>
`;
        }
        return '';
    }
}

customElements.define('search-suggestion-element', SearchSuggestionElement);
